export { default } from './PageLayout';



// WEBPACK FOOTER //
// ./src/components/PageLayout/index.js